import axios from "axios";
class Settings {
    constructor() {
        this.SETTINGS_KEY = "havi_settings";
        this.CURRENT_ENV = "havi_current_env";
        this.BASE_NAME = "base_name";
    }
    async configure({ basename, appEnv, settingsUrl: settingsUrlDefault }) {
        const currentEnv = appEnv
            ? appEnv
            : process.env.REACT_APP_ENV
                ? process.env.REACT_APP_ENV
                : window.location.host === "connect.havi.com"
                    ? "prod"
                    : window.location.host.startsWith("localhost")
                        ? "local"
                        : window.location.host.replace(".connect.havi.com", "");
        window.localStorage.setItem(this.CURRENT_ENV, currentEnv);
        const settingsUrl = settingsUrlDefault
            ? settingsUrlDefault
            : process.env.REACT_APP_SETTINGS_URL
                ? process.env.REACT_APP_SETTINGS_URL
                : "https://us2.platform.havi.com/app/settings/settings.json";
        const serverSettings = (await axios(settingsUrl)).data;
        const settings = {
            ...serverSettings,
            [this.BASE_NAME]: basename
        };
        window.localStorage.setItem(this.SETTINGS_KEY, JSON.stringify(settings));
    }
    get ApiRoot() {
        this.checkConfigured();
        if (process.env.REACT_APP_API_ROOT) {
            return process.env.REACT_APP_API_ROOT;
        }
        return this.Settings.env[this.Env].api_root;
    }
    get Env() {
        this.checkConfigured();
        return window.localStorage.getItem(this.CURRENT_ENV);
    }
    get Settings() {
        this.checkConfigured();
        return JSON.parse(window.localStorage.getItem(this.SETTINGS_KEY));
    }
    get LoginSettings() {
        this.checkConfigured();
        const redirectUri = process.env.REACT_APP_REDIRECT_URI
            ? process.env.REACT_APP_REDIRECT_URI
            : this.Env === "local"
                ? `http://${window.location.host}/`
                : `${window.location.origin}${this.Settings[this.BASE_NAME]}`;
        const envSpecificLoginSettings = {
            redirect_uri: redirectUri,
            post_logout_redirect_uri: redirectUri
        };
        return { ...this.Settings.common.login, ...envSpecificLoginSettings };
    }
    checkConfigured() {
        const isSettingsConfigured = window.localStorage.getItem(this.SETTINGS_KEY) !== null;
        const isEnvConfigured = window.localStorage.getItem(this.CURRENT_ENV) !== null;
        if (!isSettingsConfigured || !isEnvConfigured) {
            throw Error("Settings must be configured before usage");
        }
    }
}
export default new Settings();
